const endpoint = "https://jepb.cuba-go.com"
const cpoint = "https://central-backend.cuba-go.com"

const mediapoint = `${endpoint}`
const startpoint = `${cpoint}/jep/`

export { endpoint, mediapoint, startpoint }
